module.exports = __webpack_public_path__ + "2a5652c80aa749cccc279b07bfb2f77d.png";